import { Stack, Typography } from '@mui/material';
import 'dayjs/locale/en-gb';
import { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import MTRLogoImage from './assets/images/mtr_logo.png';
import { StyleConstants, Styles } from './Styles';
import { getDateTimeDisplay } from './utils/DateUtils';
import AppContext from './AppContext';
import useInterval from './hook/useInterval';

const Top = () => {
    const { pagePaths } = useContext(AppContext);

    const navigate = useNavigate();
    const { pathname } = useLocation();

    const [currentDateTime, setCurrentDateTime] = useState('');

    const loadClock = () => {
        const now = new Date();
        const dateTimeDisplay = getDateTimeDisplay(now);
        setCurrentDateTime(dateTimeDisplay);
    };

    useInterval(() => {
        // unauthorized access
        if (!(pagePaths && pagePaths.includes(pathname))) {
            navigate("/", { replace: true });
            return;
        }

        loadClock();
    }, 1000, []);

    return (
        <>
            <Stack direction="row" sx={{ height: '55px', borderBottom: '3px solid ' + StyleConstants.borderColor }}>
                <Stack direction="row" sx={{ width: '75%', alignItems: 'center' }}>
                    <img src={MTRLogoImage} alt="Logo" style={{ width: '51px', height: '42px', margin: '3px' }} />
                    <Typography sx={{ ...Styles.contentFont4 }}>
                        Phase 5 LRV - Intelligent Vehicle Monitoring System (iVMS)
                    </Typography>
                </Stack>
                <Stack direction="row" sx={{ width: '25%', textAlign: 'right' }}>
                    <Typography sx={{ ...Styles.contentFont4, width: '100%', marginRight: '3px' }}>
                        {currentDateTime}
                    </Typography>
                </Stack>
            </Stack>
        </>
    );
};

export default Top;